import {BibConfiguracaoModel} from '@/models/biblioteca/bibconfiguracao/bibconfiguracao.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';

export interface ExemplarIncompativel {
 bibExemplarId: number;
 bibDocumentoId: number;
 gesEscolaId?: number;
 valorAtual?: string;
 motivo: string;
}
export interface ResultadoAplicarTamanho {
 aplicado: boolean;
 alterados: number;
 incompativeis: ExemplarIncompativel[];
}

class BibConfiguracaoService {
 async aplicarTamanho(campo: 'tombamento' | 'codigoBarras', tamanho: number): Promise<ResultadoAplicarTamanho> {
  const acao = campo === 'tombamento' ? 'AplicarTamanhoTombamento' : 'AplicarTamanhoCodigoBarras';
  const resultado = await api.post<ResultadoAplicarTamanho>(`/BibConfiguracao/${acao}`, { tamanho });
  return resultado.data;
 }


 atualizar(bibConfiguracao: BibConfiguracaoModel): Promise<AxiosResponse> {
  return api.put('/BibConfiguracao', bibConfiguracao);
 }

 async get(): Promise<BibConfiguracaoModel> {
  const result = await api.get<BibConfiguracaoModel>(`/BibConfiguracao`);
  return result.data;
 }
}
export default new BibConfiguracaoService();
